import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  width: max-content;
  gap: 0.5rem;

  p {
    font-size: 0.875rem;
    line-height: 150%;
    font-weight: 700;
    color: rgba(67, 67, 67, 0.75);
  }

  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: ${(props) => (props.width ? props.width : "max-content")};
    color: rgba(67, 67, 67, 0.75);
    border: 1px solid #9e9e9e;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    border-radius: 3px;
    line-height: 150%;
    background: #fff;
    font-weight: 400;
    height: 2.5rem;
    gap: 2rem;
  }
`;
